import React from 'react';
import { getTeamUrl } from '../utils/routes';
import { useTeamLogo } from '../hooks/team';

export default function HeaderTeamLogo({ team }) {
  const [logo] = useTeamLogo(team.abbrv);
  return (
    <a className="team-bar__item" href={getTeamUrl(team.abbrv)}>
      <img key={team.abbrv} src={logo} alt={team.name} />
    </a>
  );
}
